var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RightTopContainer"},[_c('ContentTop',{attrs:{"title":"百姓健身房人流量排行","type":2,"topOptionsProps":_vm.sportInfo},on:{"topSelectChange":_vm.topRankSelectChange}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"14px"}},[_c('rank-list',{attrs:{"listHeight":280,"tableTitle":_vm.tableTitle,"list":_vm.areaData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }